import React, { useState } from "react";
const Login = () => {
  const [nam, setname] = useState("");
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [state, setstate] = useState("signup");
  const onsumbithandler = async (e) => {
    e.preventDefualt();
  };
  return (
    <form className="min-h-[80vh] flex  justify-center items-center">
      <div className="border min-w-[300px] sm:min-w-96 text-gray-600  flex-col flex gap-3  shadow-lg rounded-xl px-5 py-8">
        <p className="font-bold text-xl ">
          {state === "signup" ? "create account" : "login"}
        </p>
        <p className="font-semibold">please {state === "signup" ? "signup" : "login"} to book appointment</p>
        
      {state==="signup" &&
       <div>
      <p>full name</p>
          <input
            className="p-1 w-full border border-gray-300  rounded-md"
            type="text"
            value={nam}
            onChange={(e) => {
              setemail(e.target.email);
            }}
          />
        
          </div>}
        
        <div>
          <p>full email</p>
          <input
            className="p-1 w-full border border-gray-300  rounded-md"
            type="email"
            value={email}
            onChange={(e) => {
              setname(e.target.nam);
            }}
          />
        </div>
        <div>
          <p>full password</p>
            <input
            className="p-1 w-full border border-gray-300  rounded-md"
            type="password"
            value={password}
            onChange={(e) => {
              setpassword(e.target.password);
            }}
          />
        </div>
        <button
          className="w-full bg-primary text-lg text-white font-medium rounded-lg py-2 "
          type="submit"
        >
          {state === "signup" ? "create account" : "login"}
        </button>
        {state==="signup"?<p>already have an account <span onClick={()=>{setstate("login")}} className="text-primary cursor-pointer underline">login here</span></p>:
        <p>create an account <span onClick={()=>{setstate("signup")}} className="text-primary cursor-pointer underline">login here</span></p>
        }
      </div>
    </form>
  );
};

export default Login;
